const DEFAULT_TAG_IDS: number[] = [];

export default DEFAULT_TAG_IDS;
